import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const usePostsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'posts', api: api.posts }, queryVariables, queryConfig);

  return {
    posts: queryResult.resolvedData,
    latestsPosts: queryResult.latestData,
    ...queryResult,
  };
};

export const usePost = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['post', { id }], api.posts.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    post: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'posts' });

export const useCreatePost = createMutation(api.posts.create);

export const useUpdatePost = createMutation(api.posts.update);

export const useUpsertPost = createMutation(api.posts.upsert);

export const usePublishPost = createMutation(api.posts.publish);

export const useUnpublishPost = createMutation(api.posts.unpublish);
